import React, { useEffect, useState } from "react";
import axios from "axios"; //Libreria necesaria npm i axios
import { useNavigate } from "react-router-dom"; // Importa el hook useHistory
import "./CreateClass.css";
import { obtenerListadoMatriculasAlumnos, subirCertificado } from "./constants";

const modalOverlayStyle = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0, 0, 0, 0.55)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};

const modalStyle = {
  backgroundColor: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 8px 30px rgba(0, 0, 0, 0.25)",
  maxWidth: "420px",
  padding: "28px",
  textAlign: "center",
  width: "calc(100% - 40px)",
};

const progressTrackStyle = {
  backgroundColor: "#e5e7eb",
  borderRadius: "999px",
  height: "12px",
  margin: "20px 0 8px",
  overflow: "hidden",
};

export const CrearCertificado = () => {
  const navigate = useNavigate();

  // State para manejar la subida de PDF
  const [file, setFile] = useState(null);
  const [matricula_alumno, setMatriculaAlumno] = useState("");
  const [matriculasAlumnos, setMatriculasAlumnos] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [estadoCarga, setEstadoCarga] = useState(null);
  const [mensajeCarga, setMensajeCarga] = useState("");
  const [porcentajeCarga, setPorcentajeCarga] = useState(0);
  const estaSubiendo = estadoCarga === "subiendo";

  const handleRegresarButton = () => {
    if (!estaSubiendo) {
      navigate("/admin-home");
    }
  };

  useEffect(() => {
    const cargarMatriculas = async () => {
      try {
        const response = await axios.get(obtenerListadoMatriculasAlumnos);
        const listado = response.data?.data?.alumnos;

        if (!Array.isArray(listado)) {
          console.warn("Unexpected student ID response:", response.data);
          setMatriculasAlumnos([]);
          return;
        }

        setMatriculasAlumnos(listado);
      } catch (error) {
        console.error("Error loading student IDs:", error);
        setMatriculasAlumnos([]);
      }
    };

    cargarMatriculas();
  }, []);

  // Función para manejar el cambio de archivo
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
    setErrorMessage("");
  };

  // Función para manejar el cambio de matrícula
  const handleMatriculaClaseChange = (event) => {
    setMatriculaAlumno(event.target.value);
  };

  // Función para manejar la subida de PDF
  const handleSubmitPDF = async (event) => {
    event.preventDefault();
    setErrorMessage("");

    if (!file || !matricula_alumno) {
      setErrorMessage(
        "Por favor, completa todos los campos y selecciona un archivo PDF.",
      );
      return;
    }

    setEstadoCarga("subiendo");
    setMensajeCarga("Subiendo la constancia...");
    setPorcentajeCarga(0);

    const formData = new FormData();
    formData.append("archivo", file);
    formData.append("matricula_alumno", matricula_alumno);

    try {
      const response = await axios.post(subirCertificado, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          if (!progressEvent.total) {
            return;
          }

          const porcentaje = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          setPorcentajeCarga(porcentaje);
          setMensajeCarga(
            porcentaje === 100
              ? "Archivo enviado. Procesando en el servidor..."
              : "Subiendo la constancia...",
          );
        },
      });

      if (response.data.success) {
        setEstadoCarga("exito");
        setMensajeCarga(
          response.data.message || "La constancia se cargó correctamente.",
        );
      } else {
        setEstadoCarga("error");
        setMensajeCarga(
          response.data.message || "No se pudo cargar la constancia.",
        );
      }
    } catch (error) {
      console.error("Error uploading PDF:", error);
      setEstadoCarga("error");
      setMensajeCarga(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "No se pudo cargar la constancia.",
      );
    }
  };

  const handleCerrarResultado = () => {
    if (!estaSubiendo) {
      setEstadoCarga(null);
      setMensajeCarga("");
    }
  };

  return (
    <div className="full-page">
      <div className="container1">
        <form onSubmit={handleSubmitPDF}>
          <div className="title">
            <h1>Subir Constancia</h1>
          </div>
          <div className="class-name">
            <label>Matricula del Alumno</label>
            <div>
              <input
                type="text"
                list="matriculas-alumnos"
                value={matricula_alumno}
                onChange={handleMatriculaClaseChange}
                placeholder="Escribe una matrícula"
                disabled={estaSubiendo}
                required
              ></input>
              <datalist id="matriculas-alumnos">
                {matriculasAlumnos.map((alumno) => {
                  const nombreCompleto = [alumno.nombre, alumno.apellido]
                    .filter(Boolean)
                    .join(" ");
                  return alumno.matricula ? (
                    <option
                      key={alumno.id ?? alumno.matricula}
                      value={alumno.matricula}
                    >
                      {nombreCompleto}
                    </option>
                  ) : null;
                })}
              </datalist>
            </div>
          </div>
          <div className="class-description">
            <label>Archivo PDF</label>
            <div>
              <input
                type="file"
                onChange={handleFileChange}
                accept=".pdf"
                disabled={estaSubiendo}
                required
              ></input>
            </div>
          </div>
          <div className="submit">
            <button type="submit" disabled={estaSubiendo}>
              {estaSubiendo ? "Subiendo..." : "Subir PDF"}
            </button>
            {errorMessage && <div>{errorMessage}</div>}
          </div>
          <div className="underline2"></div>
        </form>
        <div className="return-home">
          <span onClick={handleRegresarButton}>Regresar Home</span>
        </div>
      </div>

      {estadoCarga && (
        <div style={modalOverlayStyle} role="presentation">
          <div
            style={modalStyle}
            role="dialog"
            aria-modal="true"
            aria-labelledby="certificate-upload-status-title"
          >
            <h3 id="certificate-upload-status-title">
              {estadoCarga === "subiendo" && "Carga en proceso"}
              {estadoCarga === "exito" && "Constancia cargada"}
              {estadoCarga === "error" && "No se pudo cargar la constancia"}
            </h3>
            <p>{mensajeCarga}</p>

            {estaSubiendo && (
              <>
                <div style={progressTrackStyle}>
                  <div
                    style={{
                      backgroundColor: "#2563eb",
                      height: "100%",
                      transition: "width 0.2s ease",
                      width: `${porcentajeCarga}%`,
                    }}
                  />
                </div>
                <p>
                  {porcentajeCarga > 0
                    ? `${porcentajeCarga}% enviado`
                    : "Preparando archivo..."}
                </p>
              </>
            )}

            {!estaSubiendo && (
              <button type="button" onClick={handleCerrarResultado}>
                Cerrar
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
